import type { FunctionComponent } from 'react';

import { Badge } from '~/ui/core/badge/Badge';

import { useChatComposerActive, useChatComposerCallbacks } from '../../../chat/chat-composer-contexts';

const useIsChatContextualPromptVisible = (): boolean => {
    const { activeChatContext, isCollapsedComposerOpen, isExpanded: isChatExpanded } = useChatComposerActive();
    const { isComposerEnabled } = useChatComposerCallbacks();

    return isComposerEnabled && activeChatContext !== null && (isChatExpanded || isCollapsedComposerOpen);
};

// Action badge that dims to a neutral "gray" variant while a contextual chat prompt
// is on screen, so the chat prompt stays the primary call to action.
export const ChatAwareActionBadge: FunctionComponent<{
    readonly label: string;
    readonly testId: string;
    readonly variant: 'info' | 'success';
    readonly onClick: () => void;
}> = ({ label, testId, variant, onClick }) => {
    const isChatContextualPromptVisible = useIsChatContextualPromptVisible();
    return (
        <Badge data-testid={testId} variant={isChatContextualPromptVisible ? 'gray' : variant} onClick={onClick}>
            {label}
        </Badge>
    );
};
